<template>
  <v-container>
    <div class="elevation-2 px-5 mt-3">
      <SimplePageHeader title="Clients" class="px-4 pr-5 mb-5">
        <template v-slot:right-buttons>
          <ButtonCustomIcon
            v-if="!isReadOnlyAccess"
            icon="add"
            color="primary"
            text="Add"
            :routeName="clientCreateRoute.name"
            :block="true"
          />
        </template>
      </SimplePageHeader>
      <ClientFilters
        class="px-5 mb-sm-5"
        :clientNames="clientNames"
        @search="handleSearchClick"
        @clear="handleSearchClick"
      ></ClientFilters>
    </div>
    <v-container fluid class="px-0 pt-2 mt-4">
      <v-layout column>
        <v-data-table
          dense
          :headers="headers"
          :items="clientList"
          class="elevation-2"
        >
          <template v-slot:item.active="{ item }">
            <v-simple-checkbox
              v-model="item.active"
              disabled
            ></v-simple-checkbox>
          </template>
          <template v-slot:item.action="{ item }">
            <v-btn
              v-if="!isReadOnlyAccess"
              class="mx-1 my-1"
              color="primary"
              outlined
              @click.prevent="editClient($event, item)"
            >
              <v-icon color="primary">edit</v-icon>
            </v-btn>
            <v-btn
              v-if="isReadOnlyAccess"
              class="mx-1 my-1"
              color="primary"
              outlined
              @click.prevent="editClient($event, item)"
            >
              <v-icon color="primary">visibility</v-icon>
            </v-btn>
          </template>
        </v-data-table>
      </v-layout>
    </v-container>
    <BottomSpacer></BottomSpacer>
  </v-container>
</template>

<script>
import { mapActions } from 'vuex'
import { mapFields } from '@/vueHelpers/vuex'
import { clientCreateRoute, clientEditRoute } from '@/lib/constants/routes'
import ClientFilters from './ClientFilters'
import { ButtonAdd, BottomSpacer, ButtonCustomIcon } from '@/components/buttons'
import { SimplePageHeader } from '@/components/pageComponents'
import { userHasRoles, getCurrentUser } from '@/lib/authentication/index'
import { ADMIN, SALES_PERSON, MANAGER } from '@/lib/constants/securityRoles'

export default {
  components: {
    ClientFilters,
    ButtonAdd,
    BottomSpacer,
    ButtonCustomIcon,
    SimplePageHeader
  },
  data () {
    return {
      clientCreateRoute,
      headers: [
        { text: 'Name', value: 'name', width: '30%' },
        { text: 'Invoice Frequency', value: 'invoiceFrequencyName', width: '20%' },
        { text: 'Third Party Portal', value: 'thirdPartyPortalName', width: '20%' },
        { text: 'Active', value: 'active', align: 'center', class: 'text-center', width: '15%' },
        { text: 'Actions', value: 'action', align: 'center', class: 'text-xs-right', width: '15%', sortable: false }
      ],
      clientNames: []
    }
  },
  computed: {
    ...mapFields('clients', [
      'clientList'
    ]),
    ...mapFields('clientFilters', [
      'name',
      'active',
      'invoiceFrequencyId',
      'thirdPartyPortalId',
      'includeInactive'
    ]),
    isReadOnlyAccess () {
      return !this.userHasRoles({ user: this.getCurrentUser(), allowedRoles: [ADMIN, MANAGER, SALES_PERSON] })
    }
  },
  methods: {
    ...mapActions('clients', [
      'getFieldsWithFilters',
      'getClients'
    ]),
    ...mapActions('clientFilters', [
      'clearFilters'
    ]),
    userHasRoles,
    getCurrentUser,
    editClient (event, client) {
      if (event.ctrlKey === true) {
        let route = this.$router.resolve({ name: clientEditRoute.name, params: { id: client.id } })
        window.open(route.href, '_blank')
      } else {
        this.$router.push({ name: clientEditRoute.name, params: { id: client.id } })
      }
    },
    handleSearchClick () {
      this.getFieldsWithFilters().then(() => {
        this.clientList = this.clientList.filter(
          (client) => (client.active || client.active === !this.includeInactive)
        )
      })
    }
  },
  created () {
    this.getClients().then((clients) => {
      this.clientNames = clients.map((client) => { return { clientName: client.name } })
      this.clientNames.sort((a, b) => (a.clientName > b.clientName) ? 1 : -1)
      this.clientList = this.clientList.filter(
        (client) =>
          client.name.includes(this.name ? this.name : '') &&
          (this.invoiceFrequencyId ? client.invoiceFrequencyId === this.invoiceFrequencyId : true) &&
          (this.thirdPartyPortalId ? client.thirdPartyPortalId === this.thirdPartyPortalId : true) &&
          (client.active || client.active === !this.includeInactive)
      )
    })
  }
}
</script>
